import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FileLines, Phone, X } from "@/components/Icon";

const STORAGE_KEY = "mp_quick_contact_dismissed_at";
const CONSENT_KEY = "mp_consent_v1";
const HIDE_HOURS = 24;

const QuickContactPopup = () => {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // During prerender: keep visible=false and mounted=false so the SSR
    // snapshot renders null, matching the client's initial hydration render.
    if (typeof window !== "undefined" && (window as unknown as { __IS_PRERENDER__?: boolean }).__IS_PRERENDER__) {
      return;
    }
    setMounted(true);
    if (location.pathname.startsWith("/offerte")) {
      setVisible(false);
      return;
    }
    const dismissedAt = Number(localStorage.getItem(STORAGE_KEY) || 0);
    if (dismissedAt && Date.now() - dismissedAt < HIDE_HOURS * 3600 * 1000) return;

    const check = () => {
      const consent = localStorage.getItem(CONSENT_KEY);
      if (consent) {
        setVisible(true);
        return true;
      }
      return false;
    };
    if (check()) return;
    const interval = setInterval(() => {
      if (check()) clearInterval(interval);
    }, 500);
    return () => clearInterval(interval);
  }, [location.pathname]);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!mounted || !visible) return null;

  return (
    <div
      className="fixed z-40 left-1/2 -translate-x-1/2 bottom-24 sm:bottom-6 w-[calc(100%-2rem)] max-w-md sm:max-w-lg animate-fade-in"
      role="dialog"
      aria-label="Offerte aanvragen"
    >
      <div className="relative flex items-center gap-3 sm:gap-4 rounded-2xl bg-[#1f7c98] text-white shadow-2xl pl-3 pr-3 py-3 sm:pl-4 sm:pr-4 sm:py-4">
        <button
          type="button"
          onClick={dismiss}
          aria-label="Sluiten"
          className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#0a2933] text-white flex items-center justify-center shadow-md hover:bg-black transition"
        >
          <X className="w-3.5 h-3.5" />
        </button>

        <div className="shrink-0 w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-white/10 flex items-center justify-center">
          <FileLines className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm sm:text-base leading-tight">Offerte nodig?</p>
          <p className="text-xs sm:text-sm text-white/80 leading-tight mt-0.5">
            Gratis &amp; vrijblijvend binnen 24 uur
          </p>
        </div>

        <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
          <Link
            to="/offerte"
            onClick={dismiss}
            className="inline-flex items-center gap-1.5 rounded-lg bg-white text-[#0a2933] px-2.5 sm:px-3.5 py-2 text-xs sm:text-sm font-bold hover:bg-white/90 transition"
          >
            <FileLines className="w-3.5 h-3.5" />
            <span className="hidden xs:inline sm:inline">Offerte</span>
          </Link>
          <a
            href="tel:+310708873306"
            className="inline-flex items-center gap-1.5 rounded-lg bg-white text-[#0a2933] px-2.5 sm:px-3.5 py-2 text-xs sm:text-sm font-bold hover:bg-white/90 transition"
          >
            <Phone className="w-3.5 h-3.5" />
            <span className="hidden xs:inline sm:inline">Bel direct</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default QuickContactPopup;
